module.exports = __webpack_public_path__ + "img/iconservice2.d53bbcdf.png";